import CheckoutButton from './CheckoutButton';

export default {
  CheckoutButton,
};
